import CitationData from './CitationData.container';
export default CitationData;
